import { namespaceActions } from 'modules/redux-utils'
import { NAME } from './constants'

const LOAD_PERSON_LIST = 'LOAD_PERSON_LIST'

export default namespaceActions(NAME)([LOAD_PERSON_LIST])
